
export interface ICustomer {
    providedName: string;
    name: string;
    firstName: string;
    houseNumber: string;
    streetName: string;
    city: string;
    state: string;
    zipCode: string;
    phonePrimary: string;
    phoneSecondary: string;
    email: string;
    notes: string;
    paymentProcessorCustomerId: string;
}


export class Customer implements ICustomer {
    public providedName: string = '';
    public name: string = '';
    public firstName: string = '';
    public houseNumber: string = '';
    public streetName: string = '';
    public city: string = '';
    public state: string = '';
    public zipCode: string = '';
    public phonePrimary: string = '';
    public phoneSecondary: string = '';
    public email: string = '';
    public notes: string = '';
    public paymentProcessorCustomerId: string = '';
}


